'use client';
import styles from './faqs-page.module.scss';
import { useEffect, useState } from 'react';
import Link from '@/components/WrappedLink';
import {
    ArrowHead,
    ChevronRight,
    ForwardWhite,
    Help,
} from '../../../public/Images';
import { FAQs } from '../../constants/FAQs';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation, useWindowDimensions } from '@/hook';
import Image from 'next/image';
import { LocalizedFAQBuy, LocalizedFAQSell, Question } from '@/types';

export default function Questions() {
    const [faqs, setFAQs] = useState<
        LocalizedFAQBuy | LocalizedFAQSell | never[]
    >([]);
    const { t, i18n, IS_RTL } = useTranslation();
    const lang = i18n.language;

    const [selectedQuestion, setSelectedQuestion] = useState<string | number>(
        ''
    );

    const { IS_DESKTOP } = useWindowDimensions();

    useEffect(() => {
        const localizedFAQs = FAQs[lang as keyof typeof FAQs];
        setFAQs(localizedFAQs);
    }, []);
    // useEffect(() => {
    //   if (width > 850) {
    //     setIsDesktop(true);
    //   } else {
    //     setIsDesktop(false);
    //   }
    // }, [width]);

    const faqAccordion = (type: 'buy' | 'sell') => {
        let faqPopularQuestions;
        if (type === 'buy' && 'buy' in faqs)
            faqPopularQuestions = faqs.buy.featured || [];
        if (type === 'sell' && 'sell' in faqs)
            faqPopularQuestions = faqs.sell.featured || [];

        return faqPopularQuestions?.map((faqQuestion: Question, i: number) => {
            return (
                <div className={styles.marginBtm16} key={i}>
                    <div
                        className={
                            selectedQuestion &&
                            selectedQuestion === faqQuestion.id
                                ? styles.accordion_active
                                : styles.accordion
                        }
                        onClick={() => {
                            setSelectedQuestion(
                                selectedQuestion === faqQuestion.id
                                    ? ''
                                    : faqQuestion.id
                            );
                        }}
                    >
                        <Typography variant="body2Medium">
                            {faqQuestion.q}
                        </Typography>
                        <div className={styles.accordion__arrow}>
                            <Image
                                src={ArrowHead}
                                alt="arrow_head"
                                style={{
                                    transform:
                                        selectedQuestion === faqQuestion.id
                                            ? 'scale(-1)'
                                            : 'scale(1)',
                                }}
                            />
                        </div>
                    </div>
                    <div
                        className={
                            selectedQuestion === faqQuestion.id
                                ? styles.accordion_active__text
                                : styles.accordion__text
                        }
                    >
                        <Typography variant="body2Medium">
                            {' '}
                            {faqQuestion.a}
                        </Typography>
                    </div>
                </div>
            );
        });
    };
    return (
        <>
            <div className={styles.content}>
                <div className={styles.pageContainer}>
                    <div
                        className={`${styles.questionsContainer} ${styles.buy}`}
                    >
                        <div className={styles.header}>
                            <div>
                                <Typography
                                    variant={
                                        IS_DESKTOP
                                            ? 'h5SemiBold'
                                            : 'subtitle1Bold'
                                    }
                                    color="white"
                                >
                                    {t('Buy Car From Sylnder')}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    className={styles.subtitle}
                                >
                                    {t('buy car subtitle')}
                                </Typography>
                            </div>

                            <Link
                                className={`${styles.forwardIcon} ${
                                    IS_RTL && styles.forwardIcon__reversed
                                }`}
                                href={`/${lang}/how-it-works/buy`}
                            >
                                <Image src={ForwardWhite} alt="forward_white" />
                            </Link>
                        </div>

                        <div className={styles.accordionContainer}>
                            {faqAccordion('buy')}
                            <Link
                                className={styles.browseBtn}
                                href={`/${lang}/how-it-works/buy`}
                            >
                                <Typography
                                    variant="subtitle2Medium"
                                    color="white"
                                >
                                    {t('Browse all questions')}
                                </Typography>
                                <Image
                                    src={ChevronRight}
                                    alt="chevron_right"
                                    className={`${styles.icon} ${
                                        IS_RTL && styles.icon__reversed
                                    }`}
                                />
                            </Link>
                        </div>
                    </div>
                    <div
                        className={`${styles.questionsContainer} ${styles.sell}`}
                    >
                        <div className={styles.header}>
                            <div>
                                <Typography
                                    variant={
                                        IS_DESKTOP
                                            ? 'h5SemiBold'
                                            : 'subtitle1Bold'
                                    }
                                    color={'white'}
                                >
                                    {t('Sell your car to Sylndr')}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    className={styles.subtitle}
                                >
                                    {t('sell your car subtitle')}
                                </Typography>
                            </div>

                            <Link
                                className={`${styles.forwardIcon} ${
                                    IS_RTL && styles.forwardIcon__reversed
                                }`}
                                href={{
                                    pathname: `/${lang}/how-it-works/sell`,
                                }}
                            >
                                <Image src={ForwardWhite} alt="forward_right" />
                            </Link>
                        </div>
                        <div className={styles.accordionContainer}>
                            {faqAccordion('sell')}
                            <Link
                                className={styles.browseBtn}
                                href={{
                                    pathname: `/${lang}/how-it-works/sell`,
                                }}
                            >
                                <Typography
                                    variant="subtitle2Medium"
                                    color={'white'}
                                >
                                    {t('Browse all questions')}
                                </Typography>
                                <Image
                                    src={ChevronRight}
                                    alt="chevron_right"
                                    className={`${styles.icon} ${
                                        IS_RTL && styles.icon__reversed
                                    }`}
                                />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className={styles.helpBanner}>
                    <Image
                        src={Help}
                        alt="help"
                        className={styles.helpBanner__icon}
                    />
                    <Typography variant="body1Medium">
                        {t('help text')}{' '}
                        <span className={styles.number}>17188</span>
                    </Typography>
                </div>
            </div>
        </>
    );
}
